import { render, staticRenderFns } from "./DisposeAdd.vue?vue&type=template&id=ccb565d0&scoped=true"
import script from "./DisposeAdd.vue?vue&type=script&lang=js"
export * from "./DisposeAdd.vue?vue&type=script&lang=js"
import style0 from "./DisposeAdd.vue?vue&type=style&index=0&id=ccb565d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb565d0",
  null
  
)

export default component.exports